module.exports = __webpack_public_path__ + "static/media/mapping3.9888d409.JPG";